import axiosConfig from './axiosConfig';

export const reportApi = {
  getProjectReport: async (id, params = {}) => {
    const response = await axiosConfig.get(`/reports/projects/${id}`, { params });
    return response.data;
  },

  getCompanyReport: async (params = {}) => {
    const response = await axiosConfig.get('/reports/company/overview', { params });
    return response.data;
  },

  getBudgetReport: async (id) => {
    const response = await axiosConfig.get(`/reports/projects/${id}/budget`);
    return response.data;
  },
};
